export const PRESENT_NAVIGATOR_ID = 'present-navigator';
export const SLIDE_SETTINGS_STORAGE_KEY = 'slideSettings';
